export const formatToProgressValue = (value: string | number | undefined) => {
  if (typeof value === 'undefined' || isNaN(value as number)) {
    return undefined;
  }

  return Number(value);
};
